import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import './Alert.sass';

const Alert = forwardRef(({ message = '', type = 'success', onClose = () => undefined }, ref) => {
  return (
    <div
      ref={ref}
      className={`alert ${type}-alert`}
      role="alert"
      aria-live="polite"
      aria-atomic="true"
      tabIndex={-1}
    >
      <h3>{message}</h3>
      <button
        type="button"
        onClick={onClose}
        className="close"
        aria-label="Close alert"
      >
        &times;
      </button>
    </div>
  );
});

Alert.displayName = 'Alert';

Alert.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  onClose: PropTypes.func
};

export default Alert;
